// extracted by mini-css-extract-plugin
module.exports = {"middleEllipsis":"MiddleEllipsis__middleEllipsis--Ei","visible":"MiddleEllipsis__visible--jz","searchable":"MiddleEllipsis__searchable--uZ"};